module.exports = __webpack_public_path__ + "img/caseImage.0c671f29.png";